import React, { createRef, useState } from 'react'
import { Avatar, IconButton } from '@mui/material'
import { Box } from '@mui/system'
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera'
import AdxDropzone from '../AdxDropzone'
import AdxErrorMessage from 'components/custom/AdxErrorMessage'

const AdxDropzoneCompanyImage = ({ file, photoUpload, setPhotoUpload, radiusLength }) => {
  // State for AdxDropzone
  const [errorFiles, setErrorFiles] = useState([])
  const [uploadState, setUploadState] = useState('PENDING')
  const dropzoneRef = createRef()

  return (file || photoUpload?.preview) && uploadState !== 'ERROR' ? (
    <Box height={radiusLength * 2} width={radiusLength * 2} borderRadius="50%" position="relative">
      <Avatar src={photoUpload?.preview || file} sx={{ height: 180, width: 180 }} />
      <Box
        position="absolute"
        bottom={0}
        right={0}
        width={45}
        height={45}
        display="flex"
        justifyContent="center"
        alignItems="center"
        borderRadius="50%"
      >
        <IconButton
          onClick={() => dropzoneRef.current.open()}
          sx={{
            padding: 0,
            width: 45,
            height: 45,
            borderRadius: '50%',
            bgcolor: 'alternate.main',
            position: 'absolute',
            right: 5,
            bottom: 5,
            border: '3px solid',
            borderColor: 'white.main',
            '&:hover': {
              bgcolor: 'green-02.main',
            },
          }}
        >
          <PhotoCameraIcon color="white" sx={{ fontSize: '15px' }} />
        </IconButton>
      </Box>
      <Box sx={{ visibility: 'hidden' }}>
        <AdxDropzone
          handleFiles={(item) => {
            setPhotoUpload(item)
          }}
          fileType={['photo']}
          iconSx={{ fontSize: '15px' }}
          variant="circle"
          mainText="Max 2mb"
          optionalText="(.jpg or .png only)"
          setUploadState={setUploadState}
          ref={dropzoneRef}
          useDropzoneObject={{
            accept: 'image/jpeg, image/png',
          }}
          setErrFiles={setErrorFiles}
        />
      </Box>
    </Box>
  ) : (
    <Box>
      <Box height={radiusLength * 2} width={radiusLength * 2} borderRadius="50%">
        <AdxDropzone
          handleFiles={(item) => {
            setPhotoUpload(item)
          }}
          fileType={['image']}
          variant="circle"
          mainText="Max 2mb"
          optionalText="(.jpg or .png only)"
          setUploadState={setUploadState}
          ref={dropzoneRef}
          useDropzoneObject={{
            accept: 'image/jpeg, image/png',
          }}
          icon="photo_camera"
          setErrFiles={setErrorFiles}
          //   change border to red if uploadState is error
          sx={uploadState === 'ERROR' && { borderColor: 'error.main' }}
        />
      </Box>
      <Box display="flex" justifyContent="center" marginTop={1}>
        {errorFiles.map((item, index) => {
          if (index === 0) {
            return item?.errors.map((list) => {
              switch (list?.code) {
                case 'file-too-large':
                  return <AdxErrorMessage children="File too big" />
                case 'file-invalid-type':
                  return <AdxErrorMessage children="Invalid file type" />
                case 'too-many-files':
                  return <AdxErrorMessage children="Too many files" />
                default:
                  return <AdxErrorMessage children="An error occured. Try resubmit file" />
              }
            })
          } else return null
        })}
      </Box>
    </Box>
  )
}

export default AdxDropzoneCompanyImage
